module.exports = __webpack_public_path__ + "img/electric_pending_zone.597a9efd.svg";